import React from 'react';
import { CustomSelectorInterface, Option } from './types';

const getOptionLabel = (e: Option | string): string => {
	if (typeof e === 'object' && e !== null) {
		if (e.label) return e.label;
	}
	return String(e);
};

export const CustomSelector: React.FC<CustomSelectorInterface> = ({
	list = [],
	label,
	labelClassName,
	onChange,
	value,
	customDivStyle,
	customSelectorStyle,
	error,
}) => {
	return (
		<div className={`flex flex-col ${customDivStyle}`}>
			{label && <label className={`content ${labelClassName}`}>{label}</label>}
			<select
				onChange={onChange}
				value={value}
				id="countries"
				className={`bg-white_ border   text-[16px]  outline-none border-normal-grey justify-center sm:min-w-[210px] h-10 mt-2 px-2 items-start py-2 flex ${customSelectorStyle}`}
			>
				{list.map((e, i) => (
					<option
						key={i}
						value={typeof e === 'object' ? e.value : e}
						disabled={
							typeof e === 'object' &&
							(e.label === 'Select' ||
								e.label === '#' ||
								e.label === 'Select a geography')
						}
					>
						{getOptionLabel(e)}
					</option>
				))}
			</select>
			{error && <span className="text-dark-red text-h5 mt-1">{error}</span>}
		</div>
	);
};
